import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, WhatsappConfigurationRespondeDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof WhatsappConfigurationRespondeDataSchema>>

const queryKey = ["whatsappIntegrationConfiguration"]

export const whatsappIntegrationQuery = () => {
  return queryOptions({
    queryKey,
    queryFn: async () => {
      const response = await axios.get<Response>(`/integrations/whatsapp/configuration`)

      return response.data.data
    },
  })
}
